var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as uuid from 'uuid';
import { createSlice, createSelector } from '@reduxjs/toolkit';
import { hasCompanyConnectJob } from '../../types/types';
export var initialState = {
    linkTokenPayload: {},
    linkToken: null,
    uniqueUserId: null,
    version: null,
    featureFlags: {},
    experiments: {},
    dynamicConfigs: {},
};
export function convertToState(options, linkTokenPayload) {
    var modalSessionId = options._modalSessionIdOverride || uuid.v4();
    var 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fireClientEvent = options.fireClientEvent, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _modalSessionIdOverride = options._modalSessionIdOverride, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    postParentWindowMessage = options.postParentWindowMessage, rest = __rest(options, ["fireClientEvent", "_modalSessionIdOverride", "postParentWindowMessage"]);
    return __assign({ linkTokenPayload: linkTokenPayload, modalSessionId: modalSessionId }, rest);
}
export var linkParamsSlice = createSlice({
    name: 'linkParams',
    initialState: initialState,
    reducers: {
        initializeLinkParams: function (_, action) {
            var _a = action.payload, options = _a.options, linkTokenPayload = _a.linkTokenPayload;
            return convertToState(options, linkTokenPayload);
        },
    },
});
export var initializeLinkParams = linkParamsSlice.actions.initializeLinkParams;
export var selectLinkToken = function (state) {
    var _a;
    return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkToken;
};
export var selectClientHostname = function (state) {
    var _a;
    return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.clientHostname;
};
export var selectLinkTokenPayload = function (state) {
    var _a;
    return ((_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) || {};
};
export var selectRequiredJobs = function (state) { var _a, _b; return ((_b = (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.requiredJobs) || []; };
export var selectIsCompanyConnectJob = createSelector(selectRequiredJobs, function (requiredJobs) {
    return hasCompanyConnectJob(requiredJobs);
});
export var selectAmount = function (state) { var _a, _b; return (_b = (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.amount; };
export var selectAllocation = function (state) { var _a, _b; return (_b = (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.allocation; };
export var selectModalSessionId = function (state) {
    var _a;
    return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.modalSessionId;
};
export var selectUniqueUserId = function (state) {
    var _a;
    return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.uniqueUserId;
};
export var selectLinkParams = function (state) { return state.linkParams; };
export var selectExperiments = function (state) { var _a; return ((_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.experiments) || {}; };
export var selectFeatureFlags = function (state) { var _a; return ((_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.featureFlags) || {}; };
export var selectDynamicConfigs = function (state) { var _a; return ((_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.dynamicConfigs) || {}; };
export var selectMode = function (state) { var _a; return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload.mode; };
export var selectLanguage = function (state) { var _a, _b; return (_b = (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.language; };
export var selectIsAppClip = function (state) { var _a; return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload.isAppClip; };
export var selectSdk = function (state) { var _a; return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.sdk; };
export var selectSdkVersion = function (state) { var _a; return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.version; };
export var selectDevicePlatform = function (state) { var _a; return (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.platform; };
export default linkParamsSlice.reducer;
